import React from 'react'
import PropTypes from 'prop-types'
import AjaxLoaderImg from './AjaxLoaderImg'

const LoadingOverlay = (props) => {
    return (
        <div className={`loading-overlay ${props.isLoading ? 'loading' : ''} ${props.className}`}>
            <div className='overlay-container'>
                <AjaxLoaderImg height='auto' />
            </div>
            {props.children}
        </div>
    )
}

LoadingOverlay.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    className: PropTypes.string
}

LoadingOverlay.defaultProps = {
    isLoading: false,
    className: ''
}

export default LoadingOverlay



// WEBPACK FOOTER //
// ./resources/js/components/LoadingOverlay.js